var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.285 9.17376C40.6967 7.28571 37.7644 6.51562 32.1642 6.51562H11.8354C6.10706 6.51562 3.12495 7.33547 1.54266 9.34555C0 11.3053 0 14.1929 0 18.1896V25.8071C0 33.5498 1.83038 37.4811 11.8354 37.4811H32.1643C37.0208 37.4811 39.7118 36.8015 41.4528 35.1353C43.2382 33.4267 44 30.6369 44 25.8071V18.1896C44 13.9748 43.8806 11.0701 42.285 9.17376ZM28.2482 23.05L19.0169 27.8745C18.8106 27.9824 18.5848 28.0359 18.3595 28.0359C18.1043 28.0359 17.8496 27.9673 17.6241 27.8307C17.1994 27.5734 16.9402 27.113 16.9402 26.6166V16.9985C16.9402 16.5029 17.1988 16.0429 17.6226 15.7854C18.0465 15.528 18.5738 15.5104 19.0137 15.7389L28.2449 20.5323C28.7146 20.7761 29.0095 21.261 29.0102 21.79C29.0108 22.3195 28.7171 22.8051 28.2482 23.05Z",
    fill: "#D7143A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.45fb0e0b709d7ac79bc163567ce31d33.svg";
export { ForwardRef as ReactComponent };